import { Autoplay, Navigation, Pagination, Keyboard } from "swiper";
import { SwiperSetup } from '@resources/swiper-setup/SwiperSetup'
import { reinitVideos, initIfAtLeast, stopIframes } from "@resources/swiper-setup/SwipertSetup.utils";
import breakpoints from '@app/scripts/breakpoints.json'

SwiperSetup.register('carousel', ({ swiperId, swiperTag, swiperEl }) => {
	return {
		modules: [Autoplay, Navigation, Keyboard, Pagination],
		direction: 'horizontal',
		loopAdditionalSlides: 2,
		loop: true,
		speed: 500,
		slidesPerView: 1,
		autoHeight: false,
		spaceBetween: 40,
		Autoplay: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		breakpoints: {
			[breakpoints.lx.breakpoint]: {
				slidesPerView: swiperEl.classList.contains('two-slides-per-view') ? 2 : 1,
			},
		},
		init: initIfAtLeast(swiperEl, swiperEl.classList.contains('two-slides-per-view') ? 2 : 1),
		on: {
			slideChange: () => {
				reinitVideos(swiperEl);
				stopIframes(swiperEl);
			}
		}
	}
})
